import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { GetOrganizationStructure } from '../../../../store/HR/Organizations/OrganizationStructureSice.js';
import { Link } from 'react-router-dom';
import Breadcrumb from '../../../../components/Shared/Breadcrumb.js';
import ModalComponent from '@components/Modal/ModalComponent.jsx';
import ShowStructure2 from './ShowStructure2.jsx';
import Loading from '@components/Shared/Loader/Loading';
import useGetOrganizationStructure from '@hooks/HR/useGetOrganizationStructure.js';

const OrganizationStructure2 = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const [orgData, setOrgData] = useState(null);

  const { Hierarchy, loading } = useGetOrganizationStructure();

  //#endregion

  var BreadcrumbList = [
    {
      name: 'Home',
      link: ':moduleHome'
    },
    {
      name: 'OrganizationalStructure',
      link: null
    }
  ];

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb BreadcrumbList={BreadcrumbList} PageName='OrganizationalStructure' />
        <div className='ms-auto'>
          <Link
            to=''
            className='btn btn-theme '
            data-bs-toggle='modal'
            data-bs-target='#modalXl'
            // onClick={() => setShow(true)}
          >
            <i className='fa fa-plus-circle fa-fw '></i> {t('عرض الهيكـليـة')}
          </Link>
        </div>
      </div>

      <hr className='m-2' />
      <Loading loading={loading}>
        {Hierarchy && Object.keys(Hierarchy).length > 0 && <ShowStructure2 Hierarchy={Hierarchy} />}
      </Loading>

      {/* <ModalComponent id='modalXl' title={'الهيكـل التظيمي للشــركة '}>
        <ShowStructure />
      </ModalComponent> */}
    </>
  );
};

export default OrganizationStructure2;
